var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import ProductItem from '../../components/ProductItem';
import CtaBlock from '../../components/CtaBlock';
import { fetchProducts } from './store/actions';
var mapStateToProps = function (state) { return ({
    collection: state.products.collection,
}); };
var mapDispatchToProps = {
    fetchProducts: fetchProducts,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var Products = /** @class */ (function (_super) {
    __extends(Products, _super);
    function Products() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Products.prototype.componentDidMount = function () {
        this.props.fetchProducts();
    };
    Products.prototype.render = function () {
        if ('loaded' !== this.props.collection.status || !Array.isArray(this.props.collection.items)) {
            return null;
        }
        var hiddenProducts = [5, 6];
        return (React.createElement("div", { className: "p-products" },
            React.createElement("div", { className: "p-products__content" },
                React.createElement("div", { className: "h-text--center" },
                    React.createElement("h1", { className: "c-title c-title--style2" }, this.props.t('products.title'))),
                React.createElement("div", { className: "h-padding-top--40" },
                    React.createElement(CtaBlock, { title: "products.cta.title", content: "products.cta.content" })),
                React.createElement("div", null,
                    React.createElement("ul", { className: "h-list-style-type--none h-margin--0 h-padding--0" }, this.props.collection.items.map(function (item, key) { return !hiddenProducts.includes(item.id) && (React.createElement("li", { key: key, className: "h-padding-top--30" },
                        React.createElement(ProductItem, { itemId: item.id, modifier: "h250" }))); })))),
            React.createElement("div", { className: "h-padding-y--30" })));
    };
    return Products;
}(React.Component));
export default connector(withRouter(withTranslation()(Products)));
